import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { isEmpty } from "lodash";
import { Button } from "@material-ui/core";
import Header from "../header/Header";
import { MediaRequestContext } from "../../context/MediaRequestContext";
import { UserContext } from "../../context/UserContext";
import PageError from "../page-error/PageError";
import MediaSearchBar from "./MediaSearchBar";
import MediaType from "./MediaType";
import "../../styles/media-search.scss";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { CREATE_MEDIA } from "../../constants/CreateMediaRequest";
import MediaRequestIdType from "./MediaRequestIdType";
import MediaSearchByIds from "./MediaSearchByIds";
import MediaCantemoFilters from "./MediaCantemoFilters";
import { ASSET_TYPE } from "../../constants/MediaSearch";

const MediaSearchRequest = () => {
  const history = useHistory();
  const {
    fetchNetworks,
    pageError,
    loading,
    recordType,
    saveToCart,
    _setActiveStep,
    idType,
  } = useContext(MediaRequestContext);
  const { isUserLoading } = useContext(UserContext);

  useEffect(() => {
    fetchNetworks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGoToCart = () => {
    _setActiveStep(1);
    history.push(CREATE_MEDIA.route);
  };

  if (loading || isUserLoading) {
    return null;
  }

  return pageError ? (
    <PageError
      title="Network Error"
      message="There was an issue loading the page data. Please try reloading the page."
      reloadBtn
      onReloadClick={fetchNetworks}
    />
  ) : (
    <Row>
      <Col>
        <div className="media-request-header-button-link">
          <Header headingText="Media Request" mode="mediaRequest" />
          {!isEmpty(saveToCart) && (
            <Button
              color="primary"
              endIcon={<ArrowForwardIosIcon />}
              className="pt-25 media-request-go-to-cart"
              size="small"
              onClick={handleGoToCart}
            >
              <span>{CREATE_MEDIA.forwardButtonLabel}</span>
            </Button>
          )}
        </div>
        <div className="mediaSearchWrapper">
          <Row className="mediaSearchContainer">
            <Col xs={1.5}>
              <MediaType />
            </Col>
            {recordType && recordType !== ASSET_TYPE.ID && recordType !== ASSET_TYPE.CANTEMO && (
              <Col xs={9}>
                <div className="autocompleteWrapper">
                  <MediaSearchBar />
                </div>
              </Col>
            )}
            {recordType === ASSET_TYPE.ID && (
              <Col xs={2}>
                <div>
                  <MediaRequestIdType />
                </div>
              </Col>
            )}
            {recordType === ASSET_TYPE.CANTEMO && (
              <Col xs={10}>
                <MediaCantemoFilters />
              </Col>
            )}
            {recordType === ASSET_TYPE.ID && idType && (
              <Col xs={8}>
                <div>
                  <MediaSearchByIds />
                </div>
              </Col>
            )}
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default MediaSearchRequest;
